import VideoAdsException from 'app/exceptions/VideoAdsException';

export default class RequestAdsException extends VideoAdsException {
  constructor(message: string) {
    super(message);
    this.name = 'RequestAdsException';
  }
}
